import { render } from "./AutoTransferSettingsModal.vue?vue&type=template&id=210f90aa&ts=true"
import script from "./AutoTransferSettingsModal.vue?vue&type=script&lang=ts"
export * from "./AutoTransferSettingsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__